import { useEffect } from "react";
import { Card, CardContent } from "../../components/ui/card";
import { config } from "../../utils/config";
import { ConversationViewer } from "./components/conversation-viewer";
import { QueryForm } from "./components/query-form";
import { ConversationProvider } from "./context/ConversationContext";
import { useWhatsapp } from "./hooks/use-whatsapp";
import { OpsOption } from "./types";

const OPS_OPTIONS_MAP: Record<string, OpsOption[]> = {
  xama_prod: [
    { key: "agility", value: "Agility" },
    { key: "muve", value: "Muve" },
    { key: "logus", value: "Logus" },
    { key: "entrego", value: "Entrego" },
  ],
  xama_dev: [
    { key: "agility", value: "Agility" },
    { key: "muve", value: "Muve" },
    { key: "logus", value: "Logus" },
    { key: "entrego", value: "Entrego" },
  ],
  rondolog_dev: [],
  rondolog_prod: [],
  xpto_dev: [],
  xpto_prod: [],
};

function WhatsappContent({ fundName }: { fundName: string }) {
  const {
    queryType,
    phoneNumber,
    opsName,
    startDate,
    endDate,
    hasConversation,
    toast,
    isLoading,
    setPhoneNumber,
    setOpsName,
    setStartDate,
    setEndDate,
    handleSelectAll,
    handleSelectSingle,
    handleLast30Minutes,
    handleSubmitAllConversations,
    handleSubmitSingleConversation,
    closeToast,
  } = useWhatsapp(fundName);

  const opsOptions = OPS_OPTIONS_MAP[fundName] || [];

  useEffect(() => {
    if (toast.open) {
      setTimeout(() => {
        closeToast();
      }, 6000);
    }
  }, [toast, closeToast]);

  const handleSubmit = () => {
    if (queryType === "all") {
      handleSubmitAllConversations();
    }
    handleSubmitSingleConversation();
  };

  return (
    <div className="p-6">
      {toast.open && (
        <div className="fixed top-4 right-4 z-50 max-w-md">
          <Card
            className={`${
              toast.variant === "destructive"
                ? "border-red-500 bg-red-50"
                : toast.variant === "success"
                  ? "border-green-500 bg-green-50"
                  : "border-blue-500 bg-blue-50"
            }`}
          >
            <CardContent className="p-4">
              <p className="text-sm font-medium">{toast.message}</p>
            </CardContent>
          </Card>
        </div>
      )}

      <QueryForm
        fundName={fundName}
        opsName={opsName}
        queryType={queryType}
        phoneNumber={phoneNumber}
        startDate={startDate}
        endDate={endDate}
        opsOptions={opsOptions}
        isLoading={isLoading}
        onOpsChange={setOpsName}
        onQueryTypeChange={(type) => {
          if (type === "all") handleSelectAll();
          else if (type === "single") handleSelectSingle();
        }}
        onPhoneNumberChange={setPhoneNumber}
        onStartDateChange={setStartDate}
        onEndDateChange={setEndDate}
        onLast30Minutes={handleLast30Minutes}
        onSubmit={handleSubmit}
      />

      {hasConversation && (
        <div className="mt-6">
          <ConversationViewer queryType={queryType} />
        </div>
      )}
    </div>
  );
}

export default function GestorWhatsapp() {
  const selectedFund = `xama_${config.stage}`;

  return (
    <ConversationProvider>
      <div className="p-6">
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-foreground">
            Mensagens do WhatsApp
          </h1>
          <p className="text-muted-foreground mt-1">
            Ver mensagens do WhatsApp
          </p>
        </div>

        <WhatsappContent fundName={selectedFund} />
      </div>
    </ConversationProvider>
  );
}
